import * as errorMessages from '../../constants/errorMessages';
import * as apiConstants from '../../constants/apiConstants';
import mode from '../mode';
require('es6-promise').polyfill();
require('isomorphic-fetch');


export function createFetchAndCall(apiPath, options) {
  //start temporary fix for the 403 forbidden on redirect issue with force password change
  let returnedForbidden = false;
  let startTime = getCurrentTime();
  //end
  return fetch(apiPath, options
  ).then(response => {
    recordGaPageView(apiPath, options, response.status, startTime);
    if (response.status >= 200 && response.status < 300) {
      return response.json();
    } else if (response.status > 300 && response.status < 500 && !apiPath.includes("apiToken")) {
      //start temporary fix for the 403 forbidden on redirect issue with force password change
      if(response.status==403 && response.url.indexOf('/user')!=-1 && response.url.indexOf('/edit')!=-1){
        returnedForbidden = true;
      }
      //end
      return response.json();
    } else if (apiPath.includes("apiToken") && response.status == 500) {
      return (errorMessages.ERROR_API_GENERATE);
    } else {
      let errorMessage =
        `${errorMessages.ERROR_SERVER} ${response.statusText}`;
      return (errorMessage);
    }
  }).then(data => {
    //start temporary fix for the 403 forbidden on redirect issue with force password change
    if(returnedForbidden && data.message.indexOf('authentication')!=-1 && data.message.indexOf('route')!=-1){
      if(window.localStorage){
        if(!localStorage.getItem('firstLoad')){
          localStorage['firstLoad']=true;
          window.location.reload(true);
        }
      }
    }
    //end
    return data;
  }).catch(error => {
    throw error;
  });
}

// Track Http requests in Google Analytics
function recordGaPageView(path, options, responseCode, startTime) {
  const genericPath = getGenericPath(path);
  const endTime = getCurrentTime();
  const responseTime = (endTime - startTime) / 1000;
  // Replace the '/oshaApi/v1/' and
  const prefix_removed = genericPath.replace('/oshaApi/v1', '');
  // Track in google analytics the page views.
  if (window.gtag) {
    console.log("Sending GA events " + options.method + " for " + path + "(" + responseCode + ")");

    // Add an event to track type of requests and the response codes
    window.gtag('event', 'page_view', {
      page_title: prefix_removed,
      page_location: path
    });

    // Add an event to track type of requests and the response codes
    window.gtag('event', options.method + "_request", {
      'event_category': 'API Requests',
      'event_label': genericPath,
      'event_timing': responseTime,
      'value': responseCode
    });
  }
}

// Get current time.
function getCurrentTime() {
  if (performance && typeof performance.now === 'function') {
    // If performance.now is available, use it
    return performance.now();
  } else {
    // Fallback to Date.now if performance.now is not available
    return Date.now();
  }
}

// Get the Generic path for recordidng as an event.
function getGenericPath(path) {
  // Array of all the standard paths from apiConstants.js
  const genericPaths = [
    '/oshaApi/v1/users/password_reset',
    '/oshaApi/v1/users/logout',
    '/oshaApi/v1/users/login/validate',
    '/oshaApi/v1/users/login',
    '/oshaApi/v1/users/apiToken',
    '/oshaApi/v1/users',
    '/oshaApi/v1/user/validate',
    '/oshaApi/v1/submissions',
    '/oshaApi/v1/organizations/ita/forms',
    '/oshaApi/v1/ita/state_plan_states',
    '/oshaApi/v1/ita/send_helpdesk_email',
    '/oshaApi/v1/forms/form300And301',
    '/oshaApi/v1/forms/form300And301',
    '/oshaApi/v1/forms/form300A',
    '/oshaApi/v1/forms/allForm300And301',
    '/oshaApi/v1/forms/allForm300A',
    '/oshaApi/v1/files/submit',
    '/oshaApi/v1/files/case-data-submit',
    '/oshaApi/v1/establishmentusers',
    '/oshaApi/v1/establishmentuser',
    '/oshaApi/v1/establishments',
    '/oshaApi/v1/custom/naics_search_api.php',
    '/oshaApi/v1/custom/check_301_req.php',
    '/oshaApi/v1/custom/check_300a_req.php',
  ];

  for (const genericPath of genericPaths) {
    // Check if the current path starts with the generic path
    if (path.startsWith(genericPath)) {
      return genericPath;
    }
  }

  // If no match is found, return the original path
  return path;
}

export function createApiPath(path, id) {
  let apiPath = path;
  if(id){
    if (path == apiConstants.naicsCodesApiPath) {
      apiPath = apiPath + '?search=' + id;
    }
    else {
      apiPath = apiPath + '/' + id;
    }

  }
  if (!mode.prod) {
    apiPath = `${apiConstants.localURL}${apiPath}`;
  }
  if (mode.debug) {
    apiPath = `${apiPath}${apiConstants.DEBUG}`;
  }
  return apiPath;
}

export function createApiPathWithMultipleParameter(path, params) {
  let apiPath = path;
  if (Array.isArray(params) && params.length > 0) {
    // Join the array of IDs with '/' and append to the URL.
    apiPath = `${apiPath}/${params.join('/')}`;
  }
  if (!mode.prod) {
    apiPath = `${apiConstants.localURL}${apiPath}`;
  }
  if (mode.debug) {
    apiPath = `${apiPath}${apiConstants.DEBUG}`;
  }
  return apiPath;
}

export function createApiPathWithQueryStrings(path, queryParams) {
  let apiPath = path;
  // Check if queryParams is an object
  if (typeof queryParams !== 'object' || queryParams === null) {
    return apiPath;
  }

  // Convert the queryParams object to a string
  const queryString = Object.keys(queryParams)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(queryParams[key]))
    .join('&');

  // Append the queryString to the URL
  apiPath = path + (queryString ? '?' + queryString : '');

  if (!mode.prod) {
    apiPath = `${apiConstants.localURL}${apiPath}`;
  }
  if (mode.debug) {
    apiPath = `${apiPath}${apiConstants.DEBUG}`;
  }
  return apiPath;
}

export function cleanWhitespace(stringToBeCleaned) {
  if(/^\s/.test(stringToBeCleaned) || /\s$/.test(stringToBeCleaned)){
    stringToBeCleaned = stringToBeCleaned.trim();
  }
  return stringToBeCleaned;
}



/** WEBPACK FOOTER **
 ** ./src/api/fetch/fetchServices.js
 **/